/**
 * Default countries for location search when no account country is set
 */
export const DEFAULT_COUNTRIES = ['au', 'gb', 'nz', 'ie', 'us', 'ca'];

/**
 * Crown Dependencies - territories associated with GB that have their own ISO codes
 * These should be searchable for UK accounts
 */
export const CROWN_DEPENDENCIES = ['im', 'je', 'gg']; // Isle of Man, Jersey, Guernsey

/**
 * Get the list of countries to search for location autocomplete
 *
 * @param {Object} options
 * @param {string[]|undefined} options.givenCountries - Explicitly provided countries (overrides account country)
 * @param {Object} options.session - Session object containing account information
 * @returns {string[]} Array of country codes to search
 */
export function getSearchCountries({ givenCountries, session }) {
  if (givenCountries != null) {
    return givenCountries;
  }

  if (!session.ready) {
    return DEFAULT_COUNTRIES;
  }

  const { accounts, currentAccountId } = session;
  const account = accounts.find((account) => account.id === currentAccountId);
  const accountCountry = account?.agencies?.data?.[0]?.address?.country?.id;

  if (typeof accountCountry !== 'string') {
    return DEFAULT_COUNTRIES;
  }

  // For GB accounts, include Crown Dependencies (Isle of Man, Jersey, Guernsey)
  if (accountCountry.toLowerCase() === 'gb') {
    return ['gb', ...CROWN_DEPENDENCIES];
  }

  return [accountCountry];
}
